import React from "react"
import { Nav, Navbar } from "react-bootstrap"

export const Header = ({ slug }) => (
    <header>
        <Navbar expand="sm" variant="dark" bg="dark">
            <Nav.Link href="/"
                className="navbar-brand"
            >Q'LU</Nav.Link>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="mr-auto">
                    <Nav.Link href="/hoken" active={slug == "/hoken"}>保険コンサルティング</Nav.Link>
                    <Nav.Link href="/trade" active={slug == "/trade"}>貿易</Nav.Link>
                    <Nav.Link href="/info" active={slug == "/info"}>会社概要</Nav.Link>
                    <Nav.Link href="/beijing-qool" active={slug == "/beijing-qool"}>北京酷楽</Nav.Link>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    </header>
)
